import { render, staticRenderFns } from "./noticePage.vue?vue&type=template&id=84d306ca&scoped=true"
import script from "./noticePage.vue?vue&type=script&lang=js"
export * from "./noticePage.vue?vue&type=script&lang=js"
import style0 from "./noticePage.vue?vue&type=style&index=0&id=84d306ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d306ca",
  null
  
)

export default component.exports